import { RelatedDocument } from '@ravago/shared/page-data/models/elements';

export class DocumentNameUtils {
   static determineAppropriateFileName = (document: RelatedDocument, pertainingToProduct?: string): string => {
      if (document.isBrandedTds || document.type.toUpperCase() === 'TDS') {
         return DocumentNameUtils.buildFileName(document.language, document.extension, 'Technical_data_sheet', 'TDS', pertainingToProduct);
      }
      if (document.isInternal) {
         return document.name.replace(/\.(.+)$/, (_fullMatch, matchedExtension) => `_INTERNAL-USE-ONLY.${matchedExtension}`);
      }
      return document.name;
   };

   static determineGenericTDSFileName = (language: string, pertainingToProduct?: string): string =>
      DocumentNameUtils.buildFileName(language, 'pdf', 'Technical_data_sheet', 'TDS', pertainingToProduct);

   private static buildFileName = (
      language: string,
      extension: string,
      defaultName: string,
      productNamePostFix: string,
      pertainingToProduct?: string
   ): string => {
      const cleanedUpProductName = pertainingToProduct ? `${pertainingToProduct.replace(/\W/g, '_')}_${productNamePostFix}` : defaultName;
      return `${cleanedUpProductName}_${language.toLowerCase()}.${extension}`.replace(/_+/g, '_');
   };
}
